import { Box, Button, CardContent, CardMedia, Divider, Typography } from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";
import CardContainer from "../../utils/CardContainer";
import { MovingText } from "../../utils/MovingText";
import { ImagePath, ImageRelativePath, Website_Url } from "../../constants";

const EventBookingCard = ({ item }) => {
    const {
        location_name,
        title,
        cover_image,
        slug
    } = item
   
    const url = `${Website_Url}CoursesDetail/${slug}`;
   
    const handleBookEvent = () => {
        window.location.href = url
    };


    return (
        <>
            <CardContainer sx={{ flexDirection: "column" }}
            >
                <CardMedia
                    sx={{
                        position: "relative",
                        height: "187px",
                        backgroundImage: `url(${ImagePath}${ImageRelativePath}${cover_image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        borderRadius: "15px",
                    }}>
                    <Box
                        sx={{
                            position: "absolute",
                            width: "55%",
                            bottom: "4px",
                            right: "7px",
                            background: "#FFFFFFCC",
                            borderRadius: "15px",
                            padding: "4px 7px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Icon icon="hugeicons:seat-selector" color="#4169E1" width="15" height="15" />
                            <Typography variant="h6" ml={1}>0</Typography>
                        </Box>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{ borderRight: "1px solid #B3B3B3" }} />
                        <Typography variant="h6" color={"blue.main"}>3km away</Typography>
                    </Box>
                </CardMedia>

                <CardContent sx={{ py: 1 }}>
                    <Typography variant="h5">{title}</Typography>
                    <Box sx={{ display: 'flex', alignItems: "center", gap: 0.5 }}>
                        <Icon icon="weui:location-outlined" color="#686868" width="12" height="12" />
                        <MovingText variant={"h6"} color={"secondary.light"} text={location_name} />
                    </Box>

                    <Button variant="contained" fullWidth onClick={handleBookEvent}>Book Tickets</Button>
                </CardContent>
            </CardContainer>

        </>

    )
}

export default EventBookingCard